import { styled, useTheme } from "@mui/material/styles";
import { motion } from "framer-motion";

const icon = {
  hidden: {
    opacity: 0,
    pathLength: 0,
  },
  visible: {
    opacity: 1,
    pathLength: 1,
  },
};

const StyledSVG = styled(motion.svg)(() => ({
  width: "100%",
}));

export type LogoProps = {
  width?: string;
  height?: string;
  viewBox?: string;
  fillColor?: string;
  strokeColor?: string;
  strokeWidth?: number;
  variants?: typeof icon;
  initial?: "hidden" | "visible";
};

export const Logo: React.FC<LogoProps> = ({
  width = "32",
  height = "33",
  viewBox = "0 0 32 33",
  strokeWidth = 0,
  variants = icon,
  fillColor,
  strokeColor,
  initial = "visible",
}) => {
  const theme = useTheme();
  const finalFillColor = fillColor ?? theme.palette.logo.fillColor;
  const finalStrokeColor = strokeColor ?? theme.palette.logo.strokeColor;
  return (
    <StyledSVG width={width} height={height} viewBox={viewBox}>
      <g fill="none" fillRule="evenodd">
        <g fill={finalFillColor}>
          <motion.path
            fill={finalFillColor}
            stroke={finalStrokeColor}
            fillRule="evenodd"
            strokeWidth={strokeWidth}
            variants={variants}
            initial={initial}
            d="M21 13.447l8.21 12.334H32l-9.61-14.437zM12.617 6.188L0 25.78h2.757L12.923 9.993 14 8.32z"
          />
          <motion.path
            fill={finalFillColor}
            stroke={finalStrokeColor}
            fillRule="evenodd"
            strokeWidth={strokeWidth}
            variants={variants}
            initial={initial}
            d="M6 25.781h19l-6.322-9.76-1.423 2.212 3.385 5.225H10.348l9.689-15.061-1.432-2.21z"
          />
        </g>
      </g>
    </StyledSVG>
  );
};
